// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"f0109390","740":"a679c805"}[chunkId] + ".chunk.css";
};